var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import animateChevronSvg from '../utils/chevronAnimation';
import '../utils/Chevron.scss';
var MenuChevron = function (_a) {
    var _b = _a.customWidthHeight, customWidthHeight = _b === void 0 ? "w-5 h-5" : _b, _c = _a.currentColor, currentColor = _c === void 0 ? "text-enblue" : _c, isOpen = _a.isOpen;
    var arrowPathRef = useRef(null);
    var linePathRef = useRef(null);
    var _d = animateChevronSvg({
        arrowPathRef: arrowPathRef,
        linePathRef: linePathRef,
    }), startTl = _d.startTl, reverseTl = _d.reverseTl;
    useEffect(function () {
        if (isOpen) {
            startTl.play();
        }
        else {
            reverseTl.play();
        }
    }, [isOpen]);
    return (_jsxs("svg", __assign({ className: "chevron " + customWidthHeight + " stroke-current chevron-custom-color", viewBox: "0 0 25 25" }, { children: [_jsx("path", { id: "arrow", ref: arrowPathRef, fill: "none", strokeWidth: "2", d: "M 6.25 12.5 L 12.5 18.75 L 12.5 18.75 L 18.75 12.5" }, void 0),
            _jsx("path", { ref: linePathRef, id: "line", className: "invisible", strokeWidth: "2", d: "M 6.25 18.75 L 12.5 18.75 L 12.5 18.75 L 18.75 18.75" }, void 0)] }), void 0));
};
export default MenuChevron;
